import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
import { PlusIcon, MinusIcon } from '../lib/icons';
const FAQS = [{
  q: '¿Hay clases en video?',
  a: 'No. Todo el contenido está organizado en material PDF para que puedas estudiarlo y consultarlo a tu ritmo.'
}, {
  q: '¿Cuándo empieza?',
  a: 'Hoy mismo. Una vez completada la compra recibís acceso inmediato al material.'
}, {
  q: '¿Tiene horarios?',
  a: 'No. Es una formación flexible: estudiás cuando y donde quieras.'
}, {
  q: '¿Tiene certificado?',
  a: 'Sí. Incluye certificado digital.'
}, {
  q: '¿Es editable?',
  a: 'Sí. El certificado digital está preparado para que puedas completarlo con tus datos.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí. Contás con 7 días de garantía para evaluar si la formación cumple tus expectativas.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Por descarga inmediata luego de completar el pago.'
}, {
  q: '¿Puedo imprimirlo?',
  a: 'Sí. El contenido está pensado para que puedas leerlo en pantalla o imprimirlo si lo preferís.'
}];
function FAQItem({
  q,
  a,
  isOpen,
  onClick
}: {
  q: string;
  a: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <article className="overflow-hidden rounded-xl border border-[#2E4F48]/20 bg-white shadow-sm" data-id="element-131" data-mp="1rmctg23cq06u">
      <button type="button" onClick={onClick} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-4 text-left transition-colors hover:bg-[#E8E0D3] sm:p-5" data-id="element-132" data-mp="25hf93gy033wu">
        <span className="text-base font-bold text-[#1C3B36] md:text-lg" data-id="element-133" data-mp="2af6z25f34fye">{q}</span>
        <span className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full ${isOpen ? 'bg-[#C2683D] text-white' : 'bg-[#E8E0D3] text-[#2E4F48]'}`} data-id="element-134" data-mp="2oege31rk140s">
          {isOpen ? <MinusIcon size={18} data-id="element-135" data-mp="2jd96b2pew4u4" /> : <PlusIcon size={18} data-id="element-136" data-mp="u0fegeo6kczn" />}
        </span>
      </button>
      {isOpen && <p className="border-t border-[#2E4F48]/15 px-4 py-4 text-sm leading-relaxed text-[#44574F] sm:px-5" data-id="element-137" data-mp="u2i4uzt8w84w">{a}</p>}
    </article>;
}
export function FAQSection() {
  const [ref, visible] = useReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-t border-[#2E4F48]/15 bg-[#EFEAE0] px-4 py-10 sm:px-6 md:py-16" data-id="element-138" data-mp="2u36xjzivmo7x">
      <div ref={ref} className={`reveal container mx-auto max-w-3xl ${visible ? 'is-visible' : ''}`} data-id="element-139" data-mp="2z0yl6hchno6b">
        <div className="mb-7 text-center" data-id="element-140" data-mp="334woz5crdn5p">
          <p className="text-xs font-bold tracking-[0.2em] text-[#C2683D]" data-id="element-141" data-mp="382g0vylzhnuh">LAS PREGUNTAS QUE MÁS RECIBIMOS</p>
          <h2 className="mt-3 font-serif text-3xl font-bold text-[#1C3B36] md:text-5xl" data-id="element-142" data-mp="3d19d7npjb8t2">Preguntas frecuentes</h2>
        </div>
        <div className="space-y-3" data-id="element-143" data-mp="3htaq9buj13k5">
          {FAQS.map((faq, index) => <FAQItem key={faq.q} {...faq} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-144" data-mp="3mruc7c94efci" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}